import React, { useState } from "react";
import sortingIcon from "../../../Assets/Icons/sorting-icon.svg";
import patientProfileImg from "../../../Assets/Images/patient-profile-img.png";
import "./style.css";
import { truncate } from "../../../Helpers";

const Table = (props) => {
  const {
    columnList,
    rowList,
    screen,
    onButtonClick,
    onIconClick,
    view,
    onShareClick,
  } = props;

  const [seeMore, setSeeMore] = useState([]);

  return (
    <table
      className="table-container"
      style={view === "demography" ? { height: "50%" } : { height: "auto" }}
    >
      {/* table head */}
      <thead>
        {/* table head row */}
        <tr
          className={
            screen === "dashboard"
              ? "table-header light-blue-bg"
              : "table-header white-bg"
          }
        >
          {/* columns */}
          {columnList.map((col) => (
            <th
              key={col.id}
              className="table-header-cell"
              style={{
                width: col.width || "auto",
                minWidth: col.minWidth || "0",
              }}
            >
              {/* column heading with subtext */}
              {col.label && (
                <div className="text-container">
                  <p className="p-600 dark-grey">{col.label}</p>
                  {col.subText && (
                    <p className="body3 body3-400 medium-grey">{col.subText}</p>
                  )}
                </div>
              )}
              {/* if column needs sorting, add sort icon */}
              {col.sortingRequired && (
                <img
                  src={sortingIcon}
                  className="sort-svg"
                  alt="sorting-icon"
                  onClick={col.sortingFunction}
                ></img>
              )}
              {/* additional columns */}
              {col.isIcon && (
                <div className="icon-container">
                  {col?.iconsList?.map((icon) => (
                    <img
                      key={Math.random()}
                      src={icon.icon}
                      alt="filter-sort-icons"
                      onClick={() => onIconClick()}
                    />
                  ))}
                </div>
              )}
            </th>
          ))}
        </tr>
      </thead>
      {/* table body */}
      <tbody
        style={
          view === "expanded"
            ? { height: "58vh" }
            : view === "demography"
            ? { height: "100%" }
            : { height: "18vh" }
        }
      >
        {/* Rows */}
        {rowList &&
          rowList?.length > 0 &&
          rowList.map(
            (row) =>
              !row.disabled && (
                <tr key={row._id} className="table-body-row">
                  {/* get info from 'tableData' field */}
                  {row.tableData.map((item, index) => (
                    <td
                      key={item.id}
                      className="table-body-cell"
                      style={{
                        width: columnList[index].width || "auto",
                        minWidth: columnList[index].minWidth || "0",
                      }}
                    >
                      {/* display image */}
                      {item.containsProfileImage && (
                        <img
                          src={patientProfileImg}
                          className="profile-img"
                          alt="profile"
                        />
                      )}
                      {/* main text with subtext/buttons */}
                      {item.text &&
                        (item.seeMoreCell ? (
                          <div
                            style={{ width: "100%", ...item?.cellTextStyle }}
                          >
                            {seeMore?.length > 0 &&
                            seeMore.find(
                              (x) => x.rowId === row._id && x.itemId === item.id
                            ) ? (
                              <p
                                className={
                                  columnList[index].label === "Impression"
                                    ? "body2 dark-grey"
                                    : "body1 dark-grey"
                                }
                              >
                                {item.text}...
                                <a
                                  onClick={() => {
                                    // close
                                    setSeeMore((prev) =>
                                      prev.filter(
                                        (x) =>
                                          !(
                                            x.rowId === row._id &&
                                            x.itemId === item.id
                                          )
                                      )
                                    );
                                  }}
                                  className="blue"
                                  style={{ cursor: "pointer" }}
                                >
                                  see less
                                </a>
                              </p>
                            ) : (
                              <p
                                className={
                                  columnList[index].label === "Impression"
                                    ? "body2 dark-grey"
                                    : "body1 dark-grey"
                                }
                              >
                                {truncate(item.text)}
                                {truncate(item.text) !== item.text && (
                                  <a
                                    onClick={() => {
                                      // open
                                      setSeeMore((prev) => [
                                        ...prev,
                                        {
                                          rowId: row._id,
                                          itemId: item.id,
                                        },
                                      ]);
                                    }}
                                    className="blue"
                                    style={{ cursor: "pointer" }}
                                  >
                                    see more
                                  </a>
                                )}
                              </p>
                            )}
                            {item.subText && (
                              <div className="subtext-container">
                                <p className="body2 dark-grey">
                                  {item.subText}
                                </p>
                                {item.subYellowButton && (
                                  <p className="subtext-yellow-box subtext-box">
                                    {item.subYellowButton}
                                  </p>
                                )}
                                {item.subGreyButton && (
                                  <p className="subtext-grey-box subtext-box">
                                    {item.subGreyButton}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div
                            style={{ width: "100%", ...item?.cellTextStyle }}
                          >
                            <p
                              className={
                                columnList[index].label === "Impression"
                                  ? "body2 dark-grey"
                                  : "body1 dark-grey"
                              }
                            >
                              {item.text}
                            </p>

                            {item.subText && (
                              <div className="subtext-container">
                                <p className="body2 dark-grey">
                                  {item.subText}
                                </p>
                                {item.subYellowButton && (
                                  <p className="subtext-yellow-box subtext-box">
                                    {item.subYellowButton}
                                  </p>
                                )}
                                {item.subGreyButton && (
                                  <p className="subtext-grey-box subtext-box">
                                    {item.subGreyButton}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                        ))}
                      {/* display any disabled button */}
                      {item.disableButton && (
                        <div
                          className={
                            item.disableButton === "Referred"
                              ? "disable-button-box grey-box"
                              : "disable-button-box yellow-box"
                          }
                        >
                          <p className="body2 dark-grey">
                            {item.disableButton}
                          </p>
                        </div>
                      )}
                      {/* display working buttons */}
                      {item.isButton && (
                        <div className="btn-container">
                          {item.buttonList.map((btn, btnIndex) => (
                            <button
                              key={btn.btntext}
                              className={
                                btn.btntext === "Share" ||
                                btn.btntext === "View" ||
                                btn.btntext === "Edit"
                                  ? "table-button light-grey-bg body2"
                                  : btn.btntext === ""
                                  ? "table-button light-blue-bg"
                                  : "table-button green-bg body2 white"
                              }
                              onClick={
                                btn.btntext === "Share"
                                  ? () => onShareClick()
                                  : () => onButtonClick(row, btnIndex)
                              }
                            >
                              {btn.btntext}{" "}
                              {btn.btnIcon && (
                                <img
                                  src={btn.btnIcon}
                                  alt="btn-icon"
                                  className={
                                    btn.btntext === "Share"
                                      ? "primary-button-icon"
                                      : "secondary-button-icon"
                                  }
                                />
                              )}
                            </button>
                          ))}
                        </div>
                      )}
                    </td>
                  ))}
                </tr>
              )
          )}
      </tbody>
    </table>
  );
};

export default Table;
